// Whether a graphics renderer's name is the CPU standing in for a graphics card (D1337). Pure: the
// name comes in, the answer goes out. `failIfMajorPerformanceCaveat` cannot answer this, as Chromium
// still returns a context on SwiftShader, and a Warp drawn there blocks the page for half a minute.

/**
 * What only software renderers call themselves, in lower case. ANGLE wraps every driver's name, and
 * names SwiftShader only when SwiftShader is what runs; a real card's name holds none of these.
 */
const SOFTWARE_NAMES = [
  "swiftshader",
  "llvmpipe",
  "softpipe",
  "lavapipe",
  "software",
  "basic render driver",
  "gdi generic",
  "mesa offscreen",
];

/**
 * True only for a name known to be software. A name that cannot be read, or says nothing, answers
 * false: a browser masking its card must not lose the shader it runs well.
 */
export function isSoftwareRenderer(renderer: string | null | undefined): boolean {
  const name = renderer?.toLowerCase() ?? "";
  return SOFTWARE_NAMES.some((software) => name.includes(software));
}
